<template>
  <div>
    <div class="mt-4">
      <h5>My Sessions</h5>
      <b-card
          v-for="(aSession, i) in sessions"
          :img-src="aSession.imgURL"
          img-alt="Card image"
          img-left class="mb-3"
          style="cursor: pointer"
          @click="handleSessionSelectionClick(aSession)"
          :key="`gat-${i}`"
      >
        <b-card-text style="color: black">
          <h4>{{ aSession.title }}</h4>
          <h6>{{ aSession.date }}</h6>
          <h6>{{ aSession.topic }}</h6>
          <p>{{ aSession.description }}</p>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Display_Sessions_MySessions",
  components: {},
  props: {
    resource: {
      type: Object,
      required: ()=>{return {}}
    },
    settings: {
      type: Object,
      required: ()=>{return {}}
    },
    sessions: {
      type: Array,
      default:()=>{return []},
      required: true
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleSessionSelectionClick(session){
     this.$emit('session-selected', session);
    },
  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
